import Select, { type SelectProps } from './Select';
export { Select as default, Select, SelectProps };